import createIcon from '../../createIcon';

/**
 * @component @name FormatListNumberedRtl
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTguNSAxN0gyMC41VjE3LjVIMTkuNVYxOC41SDIwLjVWMTlIMTguNVYyMEgyMS41VjE2SDE4LjVWMTdaTTE5LjUgOEgyMC41VjRIMTguNVY1SDE5LjVWOFpNMTguNSAxMUgyMC4zTDE4LjUgMTMuMVYxNEgyMS41VjEzSDE5LjdMMjEuNSAxMC45VjEwSDE4LjVWMTFaTTIuNSA1SDE2LjVWN0gyLjVWNVpNMi41IDE3SDE2LjVWMTlIMi41VjE3Wk0yLjUgMTFIMTYuNVYxM0gyLjVWMTFaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FormatListNumberedRtl = createIcon('FormatListNumberedRtl', [
  [
    'path',
    {
      d: 'M18.5 17H20.5V17.5H19.5V18.5H20.5V19H18.5V20H21.5V16H18.5V17ZM19.5 8H20.5V4H18.5V5H19.5V8ZM18.5 11H20.3L18.5 13.1V14H21.5V13H19.7L21.5 10.9V10H18.5V11ZM2.5 5H16.5V7H2.5V5ZM2.5 17H16.5V19H2.5V17ZM2.5 11H16.5V13H2.5V11Z',
      key: 'owk42j',
    },
  ],
]);

export default FormatListNumberedRtl;
